import React from "react";
import InterestRate from "../../common/InterestRate";

// const interestData = {
//   title: "Interest Rate / Returns",
//   description:
//     "Safe and timely airport pickups and drop-offs with our professional drivers. Whether you're catching an early flight or arriving late at night, we'll be there on time, every time. Experience stress-free airport travel with our reliable service.",
//   products: [
//     {
//       name: "[Product Name]",
//       rate: "150%",
//       duration: "How Long Rate Has Existed",
//       onReadMore: () => console.log("Product 1 Read More clicked"),
//     },
//     {
//       name: "[Product Name]",
//       rate: "150%",
//       duration: "How Long Rate Has Existed",
//       onReadMore: () => console.log("Product 2 Read More clicked"),
//     },
//     {
//       name: "[Product Name]",
//       rate: "150%",
//       duration: "How Long Rate Has Existed",
//       onReadMore: () => console.log("Product 3 Read More clicked"),
//     },
//     {
//       name: "[Product Name]",
//       rate: "150%",
//       duration: "How Long Rate Has Existed",
//       onReadMore: () => console.log("Product 4 Read More clicked"),
//     },
//   ],
// };

const Interest = ({ data }) => {
  // Access products_section from the data object
  const { interest_rates } = data || {};

  // Safely destructure products array with default empty array
  const { description = "", rates = [] } = interest_rates || {};

  return <InterestRate description={description} rates={rates} />;
};

export default Interest;
